import React from 'react'
import Sidebar from '../Sidebar'

const RouteWithSidebar = ({ children , isHideMargin}) => {
  return (
    <>
      <Sidebar />

      <main className={`content ${!isHideMargin ? 'mt-3' : ''}`}>
        {children}
      </main>
    </>
  )
}

export default RouteWithSidebar
